<template>
  <div class="app-wrap">
    <div :span="24" class="padding24 h100 overflow-x-y">
      <!-- 搜索框 -->
      <div class="search">
        <el-form :inline="true" :model="searchForm" class="demo-form-inline" @submit.native.prevent>
          <el-form-item label="">
            <el-input
              v-model="searchForm.value"
              clearable
              style="width: 360px"
              :placeholder="$t('enterprise.enterNameCode')"
              @keyup.enter.native="startSearch()"
            >
              <i
                slot="suffix"
                class="el-input__icon el-icon-search cursor-p"
                @click="startSearch()"
              />
            </el-input>
          </el-form-item>

          <!-- 添加角色按钮，同步角色按钮 -->
          <el-form-item class="float-right" style="margin-right: 0">
            <el-button type="primary" @click="goCreate">
              {{ $t('companyCenter.createBusiness') }}
            </el-button>
            <el-button type="primary" @click="syncCustom(true)">
              <svg-icon icon-class="sync" class="pass-icon" />
              {{ $t('enterprise.synchronizeEnterprise') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 角色列表-->
      <CustomTable
        ref="customTable"
        :table-loading="tableLoading"
        :table-data="tableData"
        :pagination="pagination"
        @handleSizeChange="handlePaginationChange"
        @handleCurrentChange="handlePaginationChange"
      >
        <el-table-column
          prop="tenantName"
          :label="$t('companyCenter.enterpriseName')"
          width="150"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          width="200"
          prop="socialCreditCode"
          :label="'纳税识别号'"
          show-overflow-tooltip
        />
        <el-table-column
          width="150"
          prop="address"
          :label="$t('enterprise.address')"
          show-overflow-tooltip
        />
        <el-table-column width="200" prop="tenantId" :label="$t('enterprise.tenantId')" />
        <!-- <el-table-column width="100" prop="adminInitialPassword" :label="'初始密码'" show-overflow-tooltip /> -->
        <el-table-column
          width="120"
          prop="enterpriseStructureName"
          :label="$t('enterprise.typeOfEnterprise')"
        />
        <el-table-column prop="effect" :label="$t('common.status')" width="120">
          <template slot-scope="scope">
            <div class="effect-content">
              <el-switch
                v-model="scope.row.effect"
                :active-value="true"
                :inactive-value="false"
                active-icon-class="el-icon-check"
                @change="changeSwitch(scope.row)"
              ></el-switch>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="auto"
          :min-width="140"
          prop="adminName"
          show-overflow-tooltip
          :label="$t('enterprise.administrator')"
        />
        <el-table-column
          width="auto"
          :min-width="100"
          prop="applicationStateStr"
          :label="$t('enterprise.authorizationStatus')"
        />
        <el-table-column :label="$t('public.operation')" width="120" fixed="right">
          <template slot-scope="scope">
            <el-button class="cursor-p" type="text" @click="assignMenu(scope.row)">
              {{ $t('enterprise.roleMenu') }}
            </el-button>
            <!-- <el-button type="text" class="cursor-p" @click="assignOrgUsers(scope.row)">分配跨组织用户</el-button> -->
            <!-- <el-button type="text" @click="goDetail(scope.row)">详情</el-button> -->
            <el-popover
              placement="bottom"
              trigger="hover"
              popper-class="scim-common-theme scim-common-theme-green"
              class="cursor-p self-popover hover_popover"
              :visible-arrow="false"
            >
              <span slot="reference">
                <i class="el-icon-more" style="transform: rotate(90deg)" />
              </span>
              <div class="self-popover-items">
                <p class="self-popover-item text_detail" @click="editOrg(scope.row)">
                  {{ $t('common.edit') }}
                </p>
              </div>
            </el-popover>
          </template>
        </el-table-column>
      </CustomTable>
    </div>
    <!-- 同步客户弹窗 -->
    <sync-business  v-if="syncCuctomFlag"  :visible.sync="syncCuctomFlag" @success="handleUpdateList" />
    <!-- 新建企业 -->
    <create-dialog
      v-if="orgCreateVisible"
      :visible.sync="orgCreateVisible"
      width="800px"
      @success="startSearch"
    ></create-dialog>

    <!-- 编辑企业 -->
    <org-edit-dialog
      v-if="orgEditVisible"
      :visible.sync="orgEditVisible"
      :org-data="orgData"
      width="800px"
      @success="startSearch"
    ></org-edit-dialog>
    <!-- 编辑角色菜单 -->
    <assign-menu
      v-if="editMenuVisible"
      :visible.sync="editMenuVisible"
      :loading.sync="dialogLoading"
      :tenant-id="assignTenantId"
      :tenant-name="assignTenantName"
      :web-menu-tree="webMenuTree"
      :app-menu-tree="appMenuTree"
      :parent-nodes="partentNodes"
      @success="handleUpdateList"
    />
    <!-- 分配跨组织用户 -->
    <org-assign-user
      :visible.sync="assignVisible"
      width="1350px"
      top="10vh"
      :org-id="assignTenantId"
    ></org-assign-user>
  </div>
</template>

<script>
import SyncBusiness from "./components/business-sync";
import AssignMenu from "./components/business-assign-menu.vue";
import BusinessApi from "@/api/business";
import OrgAssignUser from "./components/org-assign-user";
import CreateDialog from "./components/CreateDialog";
import OrgEditDialog from "./components/OrgEditDialog";
import { mapGetters } from "vuex";
export default {
  name: "Business",
  components: {
    SyncBusiness,
    AssignMenu,
    OrgAssignUser,
    CreateDialog,
    OrgEditDialog
  },
  data() {
    return {
      changeDialog: {
        disabled: this.disabledBtn,
        imgIcon: "success",
        title: "分配跨组织用户",
        desc: "选择新的租户管理员，原租户管理员将变为租户成员",
        form: {},
        data: {
          id: ""
        },
        formItem: [
          {
            component: "rc-select",
            prop: "id",
            placeholder: "请选择用户",
            label: "用户列表",
            api: {
              model: BusinessApi,
              name: "getUsersByOrg",
              params: {
                id: undefined,
                isOwnerUser: false
              }
            },
            replaceFields: {
              value: "id",
              label: "displayName"
            },
            loadMore: false
          }
        ]
      },
      assignVisible: false,
      searchForm: {
        value: ""
      },
      tableLoading: false,
      total: 0,
      size: 10,
      tableData: [],
      currentPage: 1,
      syncCuctomFlag: false,
      syncCuctomFlag2: false,
      pagination: {
        pageNum: 1,
        total: 0,
        pageSize: 10
      },
      editMenuVisible: false,
      dialogLoading: false,
      loading: false,
      webMenuTree: [],
      appMenuTree: [],
      // 有子菜单的id数组
      partentNodes: [],
      assignTenantId: "",
      assignTenantName: "",
      permissionList: {
        addBtn: false,
        assignMenuBtn: false
      },
      orgCreateVisible: false,
      orgEditVisible: false,
      orgData: {}
    };
  },
  computed: {
    ...mapGetters(["permissions", "tenantId"])
  },
  watch: {
    "searchForm.value"(newVal, oldVal) {
      if (!newVal && oldVal) {
        this.startSearch();
      }
    }
  },
  created() {
    this.getMenuTree();
    this.startSearch();
  },
  activated() {
    this.getMenuTree();
    this.startSearch();
  },
  methods: {
    editOrg(item) {
      this.orgData = item;
      this.orgEditVisible = true;
    },
    disabledBtn(btn) {
      return btn.prop === "confirm" && !this.changeDialog.data.id;
    },
    async allotUsers({ data }) {
      try {
        const params = {
          orgId: this.assignTenantId,
          tenantId: this.assignTenantId,
          userId: data.id
        };
        const { data: info } = await BusinessApi.allotUserToOrg(params);
        if (info) {
          this.$message.success("分配成功");
          this.assignVisible = false;
        }
      } catch (error) {
        this.assignVisible = false;
        throw new Error(error);
      }
    },
    assignOrgUsers(item) {
      const { tenantId } = item;
      this.changeDialog.formItem[0].api.params.id = tenantId;
      this.assignTenantId = tenantId;
      this.assignVisible = true;
    },
    changeSwitch(item) {
      const param = { effect: item.effect, tenantId: item.id };
      BusinessApi.updateOrgEffect(param).then(() => {
        this.$message.success(this.$t("public.updatedSuccessfully"));
      });
    },
    // 获取列表数据
    startSearch() {
      this.tableLoading = true;
      const parmas = {
        "orders[0].asc": "false",
        "orders[0].column": "createTime",
        search: this.searchForm.value,
        size: this.pagination.pageSize,
        page: this.pagination.pageNum
      };
      BusinessApi.getList(parmas).then(res => {
        this.tableLoading = false;
        const { data } = res;
        const { records = [], total = 0 } = data;
        this.tableData = records;
        this.pagination.total = Number(total);
      });
    },

    /**
     * @description: 获取菜单树
     * @param {*}
     * @return {*}
     */
    getMenuTree() {
      this.menuTree = [];
      this.loading = true;
      BusinessApi.getMenuByTenantId(this.tenantId, { parseToTree: true }).then(res => {
        this.loading = false;
        const { data } = res;
        this.webMenuTree = [
          {
            label: "根节点",
            type: "目录",
            id: "-1"
          }
        ];

        this.appMenuTree = [
          {
            label: "根节点",
            type: "目录",
            id: "-2"
          }
        ];
        this.partentNodes = [];
        const menuTree = this.handleData(data);
        const web = [];
        const app = [];

        menuTree.forEach(element => {
          if (element.clientType === "WEB") {
            web.push(element);
          } else {
            app.push(element);
          }
        });

        this.webMenuTree[0].children = web;
        this.appMenuTree[0].children = app;
      });
    },

    /**
     * @description: // 格式化菜单tree
     * @param {*} data
     * @param {*} level
     * @return {*}
     */
    handleData(data) {
      return data.map(o => {
        const typeText = o.menuType === "MENU" ? "菜单" : o.menuType === "BUTTON" ? "按钮" : "目录";
        const obj = {
          type: typeText,
          label: o.menuName,
          clientType: o.clientType,
          id: o.id
        };
        if (o.children && o.children.length) {
          this.partentNodes.push(o.id);
          obj.children = this.handleData(o.children);
        }
        return obj;
      });
    },
    // 同步客户
    syncCustom(val) {
      this.syncCuctomFlag = val;
    },
    // 跳转进入菜单授权页面
    assignMenu(row) {
      this.assignTenantId = row.tenantId;
      this.assignTenantName = row.tenantName;
      this.editMenuVisible = true;
    },
    // 条数改变|页数改变
    handlePaginationChange(data) {
      this.$set(this, "pagination", data);
      this.startSearch();
    },
    // 页数改变
    handleCurrentChange(val) {
      this.current = val;
      this.startSearch();
    },
    // 序号
    tableIndex(index) {
      return (this.pagination.pageNum - 1) * this.pagination.pageSize + index + 1;
    },
    handleUpdateList() {
      this.startSearch();
    },
    goCreate() {
      // this.$router.push({ name: 'orgCreate' });
      this.orgCreateVisible = true;
    },
    goDetail(item) {
      this.$router.push({ name: "orgDetail", query: { id: item.tenantId }});
    }
  }
};
</script>

<style lang="scss" scoped>
.router {
  cursor: pointer;
  &:hover {
    color: #00b259;
  }
}
.business--section {
  height: 100%;
  overflow-y: scroll;
  padding: 10px 20px;
}
.section--action {
  display: flex;
  margin-top: 15px;
  .section--search {
    flex: 1;
    .el-input {
      width: 350px;
    }
    .curpor-pointer {
      cursor: pointer;
    }
  }
  .section--btn {
    flex: 1;
    text-align: right;
  }
}
.section--table {
  margin-top: 10px;
}
.section--table--page {
  margin-top: 10px;
  text-align: right;
}
.padding24 {
  padding: 24px 24px 0;
}
::v-deep .scim-common-theme .self-dialog-form .el-dialog__body {
  overflow-y: hidden !important;
}
</style>
